import type { ReactNode } from 'react'
import { cx } from '@shared/lib/cx'
import { badge, dot } from './StatusBadge.css'

export type StatusTone = 'success' | 'awaiting' | 'closed' | 'informative' | 'neutral'

export type StatusBadgeProps = {
  tone: StatusTone
  label: string
  icon?: ReactNode
  size?: 'sm' | 'md'
  className?: string
  'data-testid'?: string
}

export function StatusBadge({
  tone,
  label,
  icon,
  size = 'md',
  className,
  'data-testid': testId,
}: StatusBadgeProps) {
  return (
    <span className={cx(badge({ tone, size }), className)} data-testid={testId}>
      {icon ?? <span className={dot({ tone })} />}
      {label}
    </span>
  )
}
